import { Outlet } from 'react-router-dom';

import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary.js';
import { ToolkitGenericFallback } from '../../components/ToolkitGenericFallback.js';
import { ModuleContextProvider } from '../ModuleContextProvider.js';
import { StudiesContext } from '../consts.js';
import { useNewStudiesState } from '../hooks/useNewStudiesState.js';

export function RootStudiesElement() {
  const studiesContext = useNewStudiesState();

  return (
    <ModuleContextProvider expectOrder={false}>
      <ErrorBoundary Fallback={ToolkitGenericFallback}>
        <StudiesContext.Provider value={studiesContext}>
          {studiesContext.studies.isLoading ? null : <Outlet />}
        </StudiesContext.Provider>
      </ErrorBoundary>
    </ModuleContextProvider>
  );
}
